import { render, staticRenderFns } from "./commonHeader.vue?vue&type=template&id=57a16ae8&scoped=true"
import script from "./commonHeader.vue?vue&type=script&lang=js"
export * from "./commonHeader.vue?vue&type=script&lang=js"
import style0 from "./commonHeader.vue?vue&type=style&index=0&id=57a16ae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a16ae8",
  null
  
)

export default component.exports